module.exports = __webpack_public_path__ + "static/media/产品优势-物联网与数据中台.a4025377.jpg";